<!--
    @修改人：黎柏祺
    @修改时间：2018-12-12
    @修改描述：框架升级
    @版本:v1.0.26
    -------------
    @负责人: 谢汉
    @创建时间: 2018-01-18
    @版本:v1.0.12
    @描述: 告警订阅用户分组管理页面
    -->
<template>
  <div class="alarmSubScribeEdit__content">
    <g-back :history="history"></g-back>
    <div class="mb-base">
        <el-button type="primary" @click="addUserGroup" v-g-rac="gRac('alarmSubScribeEdit_addGroup')">{{ $t('alarmSubscribe.addUserGroup') }}</el-button>
    </div>
    <div>
      <el-table-extend 
      :data="tData" 
      :head="tHead" 
      :currentChange="tCurrentChange" 
      :sizeChange="tSizeChange" 
      border>
        <template slot="control-column" slot-scope="{data}">
          <el-table-extend-control 
            :control="tableControl" 
            :data="data" 
            :label="$t('common.handle')">
          </el-table-extend-control>
        </template>
      </el-table-extend>
    </div>
    <el-dialog :closeOnClickModal="false" :title="$t('alarmSubscribe.addUserKindGroup')" :visible.sync="userFormVisible" width="500px">
      <el-form :model="userForm" label-position="right" label-width="100px" ref="userForm" :rules="rules" >
      <el-form-item :label="$t('alarmSubscribe.userGroupName')" prop="groupName">
        <el-input v-model="userForm.groupName"></el-input>
      </el-form-item>
      <el-form-item :label="$t('alarmSubscribe.remark')">
        <el-input type="textarea" v-model="userForm.remark" :autosize="{ minRows: 5}"></el-input>
      </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="resetForm">{{$t('common.cancel')}}</el-button>
        <el-button type="primary" @click="e_confirmAddGroup">{{$t('common.save')}}</el-button>
      </div>
    </el-dialog>
    <el-dialog :closeOnClickModal="false" :title="$t('alarmSubscribe.addUser')" :visible.sync="addFormVisible">
      <el-form :model="addForm" label-position="right" label-width="100px" ref="addForm">
        <el-form-item :label="$t('alarmSubscribe.userList')" input-width="auto">
          <el-transfer  ref="transfer" v-model="addForm.userList" :data="userList"></el-transfer>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="resetAddForm">{{$t('common.cancel')}}</el-button>
        <el-button type="primary" @click="e_confirmAddUser">{{$t('common.save')}}</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
  import rac from '@/plugins/rac-mixin'
  import table from '@/components/mixins/table'
  import AlarmSubscribeBiz from '@/logic/systemSetting/systemSettingBiz'
  import validateConfig from '@/utils/validate'
  import TimeFormat from '@/utils/timeFormat'
  export default {
    mixins: [rac, table],
    components: {
    },
    data () {
      const that = this
      return {
        userForm: {
          groupName: '',
          remark: ''
        },
        userFormVisible: false,
        addForm: {
          userList: []
        },
        addFormVisible: false,
        rules: {
          groupName: [{...validateConfig.common.notEmpty}]
        },
        tableControl: [
          {
            label: that.$t('common.add'),
            callback: that.e_add,
            rac: () => that.gRac('alarmSubScribeEdit_add')
          }, {
            label: that.$t('common.delete'),
            callback: that.e_delete,
            rac: () => that.gRac('alarmSubScribeEdit_delete')
          }
        ],
        history: [],
        userList: [],
        tempgroup: []
      }
    },
    methods: {
      e_confirmAddUser () {
        AlarmSubscribeBiz.addUserInfo(this.addForm).then(() => {
          this.$message({
            message: this.$t('common.success'),
            type: 'success'
          })
          setTimeout(() => {
            this.addForm = {
              userList: []
            }
            this.$refs.transfer.clearQuery('left')
            this.addFormVisible = false
            this.search()
          }, 500)
        })
      },
      e_getUser () {
        AlarmSubscribeBiz.getSubscribe({
          perPageCount: 1000,
          currPage: 1
        }).then((data) => {
          const userListObj = []
          data.dataList.forEach(function (item) {
            let obj = {
              lable: item.userName,
              key: item.userName
            }
            userListObj.push(obj)
          })
          this.userList = [...userListObj]
          this.search()
        })
      },
      initTable () {
        this.tInitTable({
          lanKey: 'alarmSubscribe.table',
          head: ['groupName', 'remark', 'createTime'],
          requestFun: this.search,
          headOpt: {}
        })
      },
      init () {
        this.history = []
        this.history.push({ name: this.$t('alarmSubscribe.groupManage') })
        this.initTable()
        this.e_getUser()
      },
      addUserGroup () {
        AlarmSubscribeBiz.getGroup({perPageCount: 500}).then((d) => {
          d.dataList.forEach((item) => {
            this.tempgroup.push(item.groupName)
          })
          this.userFormVisible = true
        })
      },
      resetForm () {
        this.userFormVisible = false
      },
      resetAddForm () {
        this.addFormVisible = false
      },
      e_confirmAddGroup () {
        this.$refs.userForm.validate((valid) => {
          if (valid) {
            if (this.tempgroup.includes(this.userForm.groupName)) {
              this.$message({
                message: this.$t('alarmSubscribe.exist'),
                type: 'warning'
              })
              return
            }
            AlarmSubscribeBiz.addGroup(this.userForm).then(() => {
              this.$message({
                message: this.$t('common.success'),
                type: 'success'
              })
              setTimeout(() => {
                this.userForm = {
                  groupName: '',
                  remark: ''
                }
                this.userFormVisible = false
                this.search()
              }, 500)
            })
          }
        })
      },
      search () {
        AlarmSubscribeBiz.getGroup({ ...this.tPageInfo }).then((data) => {
          if (data && data.dataList) {
            data.dataList.map((item) => {
              item.createTime = TimeFormat.getFormatTime(item.createTime)
            })
          }
          this.tData = data
        }).catch((err) => {
          console.error(err)
        })
      },
      e_add (rowData) {
        this.addForm.userList = rowData.userList
        this.addForm.id = rowData.id
        this.addForm.groupName = rowData.groupName
        this.addFormVisible = true
      },
      e_delete (rowData) {
        this.$confirm(this.$t('common.deleteTips'), this.$t('common.tips'), {
          type: 'warning'
        }).then(() => {
          AlarmSubscribeBiz.deleteGroups({
            id: rowData.id
          }).then((data) => {
            this.$message({
              message: this.$t('common.success'),
              type: 'success'
            })
            this.search()
          })
        }).catch(() => {

        })
      }
    },
    mounted () {
      this.init()
    },
    watch: {
      '$route' (newV, oldV) {
        if (newV.name === 'alarmSubscribeEdit' && oldV.name === 'alarmSubscribe') {
          this.e_getUser()
        }
      }
    }
  }
</script>
